<script setup>
import { WButton } from '@alice-health/wonderland-vue'
import { computed } from 'vue'

import { ChannelStatus, VIDEOCALL_STATUS_CONTROL } from '@/models/channels'
import { useStore } from '@/wrappers/store'

const props = defineProps({
  channel: {
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean
  }
})

const emit = defineEmits(['onStartVideocall', 'onCloseChannel'])

const { mapState } = useStore()
const { channels } = mapState('permissions')

const channelActive = computed(
  () => props.channel.status === ChannelStatus.ACTIVE
)

const showStartVideocall = computed(() => {
  return (
    props.channel.virtualClinicStatusControl ===
      VIDEOCALL_STATUS_CONTROL.READY_TO_START_VIDEO_CALL ||
    props.channel.virtualClinicStatusControl ===
      VIDEOCALL_STATUS_CONTROL.MEMBER_QUEUE_EXPERIENCE_READY_TO_START_VIDEO_CALL
  )
})
const showCloseChannel = computed(() => {
  return (
    (props.channel.virtualClinicStatusControl ===
      VIDEOCALL_STATUS_CONTROL.VIDEO_CALL_FINISHED ||
      props.channel.virtualClinicStatusControl ===
        VIDEOCALL_STATUS_CONTROL.VIDEO_CALL_REJECTED ||
      props.channel.virtualClinicStatusControl ===
        VIDEOCALL_STATUS_CONTROL.MISSING_MEMBER_INTERACTION ||
      props.channel.virtualClinicStatusControl ===
        VIDEOCALL_STATUS_CONTROL.DROP_BEFORE_VIDEO_CALL) &&
    channels.value.staff.canShowArchiveButtonInChannel
  )
})
const showReturnToVideocall = computed(() => {
  return (
    props.channel.virtualClinicStatusControl ===
      VIDEOCALL_STATUS_CONTROL.VIDEO_CALL_IN_PROGRESS ||
    props.channel.virtualClinicStatusControl ===
      VIDEOCALL_STATUS_CONTROL.MEMBER_LEFT_VIDEO_CALL
  )
})
</script>

<template>
  <div v-if="channelActive" class="channel-actions">
    <WButton v-if="showStartVideocall" @click="emit('onStartVideocall')">
      Iniciar chamada
    </WButton>
    <WButton
      v-if="showCloseChannel"
      :disabled="disabled"
      @click="emit('onCloseChannel')"
    >
      Encerrar atendimento
    </WButton>
    <WButton
      v-if="showReturnToVideocall"
      data-dd-action-name="virtual-clinic_return-call"
      @click="emit('onStartVideocall')"
    >
      Retornar à chamada
    </WButton>
  </div>
</template>

<style lang="scss" scoped>
.channel-actions {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
